import "../styles/card.css"
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Button } from "antd"
import Typography from '@material-ui/core/Typography';
import { Link } from "react-router-dom"

const useStyles = makeStyles({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
});

export default function MediaCard({ img, title, description, link, color, Width, transprent, headingcolor }) {
    const classes = useStyles();
    return (
        <Card
            // className={classes.root}
            className="card-item"
            style={{ background: transprent ? ("transparent") : ("inherit") }}
        >
            <CardActionArea>
                <img src={img}
                    style={{ width: Width ? Width : "100%", height: "100%", paddingTop: "30px", paddingBottom: "20px" }}
                />
                {/* <CardMedia
                    className={classes.media}
                    image={img}
                    title={title}
                    // style={{ backgroundColor: "green" }}
                /> */}
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" style={{ color: color ? headingcolor : "#cef", fontSize: "200%" }}>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p" style={{ color: color ? color : "#cef" }}>
                        {/* {description} */}
                    </Typography>
                </CardContent>
            </CardActionArea>
            {
                link ? (
                    <CardActions>
                        <Link to={link} className="card-link" style={{ "background": "rgb(29,54,73)" }}>
                            {/* // size="medium" type="text" onClick={handleClick}> */}
                            Learn more
                        </Link>
                    </CardActions>
                ) : (
                    null
                )
            }
        </Card >
    );
}
